import { RequestType } from 'core/domain/RequestType'
import { BASE_API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'
import { SentryWrapper } from 'core/infra/sentry/SentryWrapper'
import { ZendeskRepository } from 'core/infra/zendesk/TryZendeskRepository'

export type GetIntegrationFactoryDependencies = {
  zendeskRepository: ZendeskRepository
}

export function requestZendeskFactory({
  zendeskRepository,
}: GetIntegrationFactoryDependencies) {
  return async function (
    requestType: RequestType,
    name: string,
    company:  string,
    email: string,
    phone: string,
    config?: { signal?: AbortSignal }
  ) {
    try {
      await zendeskRepository.requestZendesk(requestType, name, company, email, phone, config)
    } catch (error) {
      SentryWrapper.log(error as Error)
      throw error
    }
  }
}

export function requestZendesk(
  requestType: RequestType,
  name: string,
  company:  string,
  email: string,
  phone: string,
  config?: { signal?: AbortSignal }
) {
  const httpClient = new HttpClient(BASE_API_URL)

  const zendeskRepository = new ZendeskRepository({ httpClient })

  const get = requestZendeskFactory({ zendeskRepository })

  return get(requestType, name, company, email, phone, config)
}
